export default __webpack_public_path__ + "static/nf-b26461457e7547cce62db8d5adbcb41e.svg";